export default __webpack_public_path__ + "static/media/banner1.47cbdf66.jpeg";